import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton, SecondaryButton, DangerButton } from "../../components/Buttons.jsx";
import { addToast, checkSession } from "../../store/app/action.js";
import { updateMerchantUser } from "../../api/index.js";
import MFASection from "../../components/MFASection.jsx";

function AccountPanel() {
  const { user, selectedLocation } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const [amSoDirty, setAmSoDirty] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
  });

  // Initialize form data when user data changes
  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || "",
        last_name: user.last_name || "",
        email: user.email || "",
      });
    }
  }, [user]);

  const checkDirty = (e) => {
    // Check if any field has been modified from its initial value
    const keysToCheck = ["first_name", "last_name", "email"];
    const dirty = keysToCheck.some((key) => {
      const currentValue =
        e.target.name === key ? e.target.value : formData[key];
      return user[key] !== currentValue;
    });
    setAmSoDirty(dirty);
  };
  const submit = async (e) => {
    e.preventDefault();
    const data = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
    };
    try {
      await updateMerchantUser(data);
      dispatch(
        addToast({ type: "success", message: "Account updated", timer: 5 })
      );
      try {
        await dispatch(checkSession());
      } catch (e) {
        // If VPN check fails during account update, show error
        dispatch(
          addToast({
            type: "error",
            message:
              e.message || "Session validation failed. Please log in again.",
            timer: 10,
          })
        );
      }
      setAmSoDirty(false);
    } catch (e) {
      let message = "please try again";
      try {
        const serverMessage = e.response?.data?.error;
        if (serverMessage) {
          message = serverMessage;
        }
      } catch {}

      dispatch(
        addToast({
          type: "error",
          message: "Error updating account " + message,
          timer: 5,
        })
      );
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="grow">
      <form onSubmit={submit}>
        {/* Panel body */}
        <div className="p-6 space-y-6">
          <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-5">
            My Account
          </h2>
          <section>
            <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-5 mb-5">
              <div className="sm:w-1/3 ">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="name"
                >
                  First Name
                </label>
                <input
                  className="form-input w-full"
                  name={"first_name"}
                  type="text"
                  value={formData.first_name}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      first_name: e.target.value,
                    }));
                    checkDirty(e);
                  }}
                />
              </div>
              <div className="sm:w-1/3 mt-4 sm:mt-0">
                <label
                  className="block text-sm font-medium mb-1"
                  htmlFor="name"
                >
                  Last Name
                </label>
                <input
                  className="form-input w-full"
                  name={"last_name"}
                  type="text"
                  value={formData.last_name}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      last_name: e.target.value,
                    }));
                    checkDirty(e);
                  }}
                />
              </div>
            </div>
            <div className="sm:w-1/3 mt-4 sm:mt-0 ">
              <label className="block text-sm font-medium mb-1" htmlFor="name">
                Email
              </label>
              <input
                className="form-input w-full"
                name={"email"}
                type="text"
                value={formData.email}
                onChange={(e) => {
                  setFormData((prev) => ({ ...prev, email: e.target.value }));
                  checkDirty(e);
                }}
              />
            </div>
          </section>
          {/* Email */}
        </div>
        {/* Panel footer */}
        <footer>
          <div className="flex flex-col px-6 py-5 border-t border-slate-200 dark:border-slate-700">
            <div className="flex self-end">
              <PrimaryButton
                type="submit"
                disabled={!amSoDirty}
                loading={loading}
              >
                Save Changes
              </PrimaryButton>
            </div>
          </div>
        </footer>
      </form>

      {/* Password Section */}
      <div className="p-6">
        <section>
          <h2 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1">
            Password
          </h2>
          <div className="mt-5">
            <PrimaryButton
              onClick={(e) => {
                e.preventDefault();
                dispatch({
                  type: "SET_CHANGE_PASSWORD_MODAL_OPEN",
                  payload: true,
                });
              }}
            >
              Set New Password
            </PrimaryButton>
          </div>
        </section>
      </div>

      {/* Multi-Factor Authentication */}
      {user?.type !== "prospect" && (
        <div className="p-6">
          <section>
            <MFASection />
          </section>
        </div>
      )}
    </div>
  );
}

export default AccountPanel;
